__turbopack_context__.v({
  "gridSide": "Templates-module-scss-module__FxxB5G__gridSide",
  "stickyHeader": "Templates-module-scss-module__FxxB5G__stickyHeader",
});
